/* eslint-disable import/no-default-export */
import { combineReducers } from 'redux';

import type { BoardStarState } from './board-stars';
import boardStars from './board-stars';
import type { BoardState } from './boards';
import boards from './boards';
import type { CardState } from './cards';
import cards from './cards';
import type { EnterpriseState } from './enterprises';
import enterprises from './enterprises';
import type { LabelState } from './labels';
import labels from './labels';
import type { ListState } from './lists';
import lists from './lists';
import type { MemberState } from './members';
import members from './members';
// The saved searches state can be deleted entirely once Cross Product Search ships to 100%.
import type { SavedSearchState } from 'app/src/components/ReduxSearch/saved-searches';
import savedSearches from 'app/src/components/ReduxSearch/saved-searches';
import type { SearchState } from 'app/src/components/ReduxSearch/search-actions';
import search from 'app/src/components/ReduxSearch/search-actions';
import type { SessionState } from './session';
import session from './session';
import type { ShortLinkMapState } from './shortLinkMap';
import shortLinkMap from './shortLinkMap';
import type { TeamState } from './teams';
import teams from './teams';

export interface ModelState {
  boardStars: BoardStarState;
  boards: BoardState;
  cards: CardState;
  enterprises: EnterpriseState;
  labels: LabelState;
  lists: ListState;
  members: MemberState;
  savedSearches: SavedSearchState;
  search: SearchState;
  session: SessionState;
  shortLinkMap: ShortLinkMapState;
  teams: TeamState;
}

export default combineReducers({
  boardStars,
  boards,
  cards,
  enterprises,
  labels,
  lists,
  members,
  savedSearches,
  search,
  session,
  shortLinkMap,
  teams,
});
